module.exports = __webpack_public_path__ + "img/bg_contact.a5a1ffe6.jpg";